import { Injectable } from '@angular/core';
import { RmsBasicCrudService } from '../../../core/components/rms-basic-crud.service';
import { HttpClient } from '@angular/common/http';
import { UtilsService, ExceptionService, PaginatedList } from '../../../xform-compat';
import { Observable } from 'rxjs';
import { MilestoneEventRecord } from '../../../shared/models';


@Injectable({
  providedIn: 'root'
})
export class KeyInflectionDataService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }


  /**
   * Get the filtered list or default list for key indlections
   * @param body
   * @param pagesize
   * @param page
   */
  public getKeyInflections(pagesize?: number, page?: number, params?: Record<string, any>): Observable<PaginatedList<MilestoneEventRecord>> {
    return super.getData('/api/rms/keyinflection/all', { page, pagesize, ...params });
  }


}
